// extracted by mini-css-extract-plugin
module.exports = {"Align":"Modal_Align__2R4b4","Modal":"Modal_Modal__24qpM","Button":"Modal_Button__Gxx80"};